export default __webpack_public_path__ + "static/heroSecretLab-f4c6c4428bb88812276e1eb93c03d3d1.jpg";